import process from "prop-types/prop-types.js";

const production = process.env.NODE_ENV === 'production'

const baseURL = ''

export const config =  `${baseURL}/api`
export const wsconfig = `${baseURL}/ws`
